var _rect, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBranches(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    fill: "url(#pattern0_173_965)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_173_965",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_173_965",
    transform: "scale(0.01)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_173_965",
    width: 100,
    height: 100,
    preserveAspectRatio: "none",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAACXBIWXMAAAsTAAALEwEAmpwYAAAClUlEQVR4nO2cvW4TQRhFp0E8Ag0tEhKlhQTN3rtWCr8AFXTwAkBBh1KSR6B2l1fgFVCqUNLSINEQ0aRYNNJEWcMk641/dnZ9jvRV3t25nmMn/saeDQEAAAAAAAAAAABCXdcz2+9sfxhDSXozn88fhKkxm83u2V7absZWki5svwxTQtLJ0BPrzeqyqqqnYQosFov7tn8XMKnNhrUMU6CqqkcFTGazhToLU6Cu6ycFTGazaUk6D1MAIYWBkBEKkfRN0tchy/YPhKSKxwydU9IxQhCyfxBSGAiZgBDbpx3nnHaNu8YHiRft4xGCkGFASGEg5DCE/Fqj0esS8r1PY2j7zx0bzmVRS/c7EtKMrC4lvQolgBBfvSMvivg6GCFu1+swRiFVVT2P/3SVakKCPoYpdOrq+AQ0lorPIwwNQowQF1qHJOSnpE9DV8yBEJfTRcccCDFCeoEQj19I3z5EGSHt82+oh7fljo93XeNghPRtBJURssY5/01om/RCuPUamXMQYoT0AyEeTkj8pbukx3FjzlWt88TiMe1zbH9ByIYbcuIekLS5pdl3CSGrDL07Sgi5Jv2JGUyGEbKK7fcIKUhICSuxolNfCYGQBEKMkFwIhIxJSPxBWrvpu0tJ+oyQ9UPsfGlcLL/3CoGQBEKMkK1MVlrNvbEkPdv3GP8SH++6xpSE7HyrgHuOcTCdOkKMkAhCEBIQYoTkgiMkgRAjJBecPmTsQkocYxsgxAjJhUBIAiFGSC4EQhIIMUJyIRCSQIgRkgtBp55AiBGSC46QBEKMkFxwhCQQYoTkgiMkgRAjJBf8eNd3WdAexpjMnRzo1K9BiBGSC4GQwoQcddxp7e0YxtgGMUdHzqOtDAQAAAAAAAAAABDK4y+wJvUNK96ABAAAAABJRU5ErkJggg=="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBranches);
export default __webpack_public_path__ + "static/media/branches.756969c0dc52b698f684fd6e97493abc.svg";
export { ForwardRef as ReactComponent };